import React from 'react';
import { Search, MoreVertical, Plus, MessageCircle, RefreshCw, FileText, LayoutList, Edit, Phone, Calendar, MessageSquare, List, ListFilter, Smile, Image, Paperclip, Star, Circle, MoreHorizontal, ChevronDown, Settings } from 'lucide-react';
export const ChatInterface = () => {
  return <div className="flex flex-1 border-r" data-id="element-289">
      {/* Left side - Chat List */}
      <div className="w-[360px] border-r flex flex-col" data-id="element-290">
        {/* Tabs */}
        <div className="flex border-b" data-id="element-291">
          <div className="px-6 py-3 font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-292">
            Inbox
          </div>
          <div className="px-6 py-3 text-gray-600" data-id="element-293">Departments</div>
          <div className="flex items-center ml-auto px-2" data-id="element-294">
            <RefreshCw size={18} className="text-gray-500 mx-2" data-id="element-295" />
            <FileText size={18} className="text-gray-500 mx-2" data-id="element-296" />
            <LayoutList size={18} className="text-gray-500 mx-2" data-id="element-297" />
          </div>
        </div>
        {/* Chat list */}
        <div className="flex-1 overflow-y-auto" data-id="element-298">
          <div className="flex items-center justify-between p-3" data-id="element-299">
            <div className="flex items-center" data-id="element-300">
              <span className="text-sm font-medium" data-id="element-301">Chats (23)</span>
              <ChevronDown size={16} className="ml-1 text-gray-500" data-id="element-302" />
            </div>
          </div>
          <ChatItem initials="SJ" name="Sarah Johnson" message="Okay, thanks!" time="5m" category="Auto loans" bgColor="bg-orange-200" active={true} data-id="element-303" />
          <ChatItem initials="SJ" name="Dario Lessing" message="Okay, thanks!" time="5m" category="Mortgages" bgColor="bg-green-200" badge="12" data-id="element-304" />
          <ChatItem initials="SJ" name="Richard Walters" message="Okay, thanks!" time="5m" category="Lending" bgColor="bg-orange-200" data-id="element-305" />
          <ChatItem initials="SJ" name="Thomas Anderson" message="Okay, thanks!" time="5m" category="Lending" bgColor="bg-green-200" badge="12" data-id="element-306" />
          <ChatItem initials="SJ" name="Emma Olivers" message="Okay, thanks!" time="5m" category="Mortgages" bgColor="bg-blue-200" data-id="element-307" />
        </div>
        {/* Collapsible sections */}
        <CollapsibleSection title="Texts (23)" data-id="element-308" />
        <CollapsibleSection title="Voicemails (23)" data-id="element-309" />
        <CollapsibleSection title="Offline messages (2)" data-id="element-310" />
      </div>
      {/* Right side - Chat Area */}
      <div className="flex-1 flex flex-col" data-id="element-311">
        {/* Chat header */}
        <div className="flex items-center justify-between p-3 border-b" data-id="element-312">
          <div className="flex items-center gap-3" data-id="element-313">
            <div className="w-10 h-10 bg-blue-500 rounded flex items-center justify-center" data-id="element-314">
              <MessageSquare size={20} className="text-white" data-id="element-315" />
            </div>
            <div data-id="element-316">
              <div className="flex items-center gap-2" data-id="element-317">
                <span className="font-medium" data-id="element-318">Sarah Johnson</span>
                <Edit size={14} className="text-gray-400" data-id="element-319" />
                <Phone size={14} className="text-gray-400" data-id="element-320" />
              </div>
              <div className="text-sm text-gray-500" data-id="element-321">+1 (123) 456 78 90</div>
            </div>
          </div>
          <div className="flex items-center" data-id="element-322">
            <div className="flex items-center mr-4" data-id="element-323">
              <img src="https://media.istockphoto.com/id/1337144146/vector/default-avatar-profile-icon-vector.jpg?s=612x612&w=0&k=20&c=BIbFwuv7FxTWvh5S3vB6bkT0Qv8Vn8N5Ffseq84ClGI=" alt="User" className="w-6 h-6 rounded-full" data-id="element-324" />
              <span className="text-sm ml-2" data-id="element-325">Andrew Raynold</span>
              <ChevronDown size={16} className="ml-1 text-gray-500" data-id="element-326" />
            </div>
            <button className="bg-[#1bbf9c] text-white rounded-md px-4 py-1.5 text-sm flex items-center" data-id="element-327">
              <Circle size={14} className="mr-1 fill-white" data-id="element-328" />
              Complete
            </button>
            <MoreHorizontal size={20} className="ml-3 text-gray-500" data-id="element-329" />
          </div>
        </div>
        {/* Tabs */}
        <div className="flex border-b" data-id="element-330">
          <div className="px-6 py-3 font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-331">
            Messages
          </div>
          <div className="px-6 py-3 text-gray-600" data-id="element-332">Workflows</div>
          <div className="px-6 py-3 text-gray-600" data-id="element-333">Co-browse</div>
          <div className="px-6 py-3 text-gray-600" data-id="element-334">Salesforce</div>
        </div>
        {/* Chat messages */}
        <div className="flex-1 p-4 overflow-y-auto" data-id="element-335">
          <div className="flex justify-center mb-6" data-id="element-336">
            <div className="bg-gray-100 text-gray-500 text-sm px-3 py-1 rounded-full flex items-center" data-id="element-337">
              <Calendar size={14} className="mr-2" data-id="element-338" />
              Today, November 25th
            </div>
          </div>
          <div className="flex items-start mb-6" data-id="element-339">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-xs font-medium mr-3" data-id="element-340">
              SJ
            </div>
            <div className="max-w-[70%]" data-id="element-341">
              <div className="font-medium mb-1" data-id="element-342">Sarah Johnson</div>
              <div className="bg-white border p-3 rounded-lg shadow-sm" data-id="element-343">
                Hi, I need help understanding my credit card statement.
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-344">09:37 AM</div>
            </div>
          </div>
        </div>
        {/* Message composer */}
        <div className="border-t p-3" data-id="element-345">
          <div className="flex mb-2" data-id="element-346">
            <div className="flex items-center gap-2 mr-4" data-id="element-347">
              <MessageSquare size={18} className="text-blue-500" data-id="element-348" />
              <span className="text-blue-500 font-medium" data-id="element-349">Text</span>
            </div>
            <div className="flex items-center gap-2 text-gray-500 mr-4" data-id="element-350">
              <MessageCircle size={18} data-id="element-351" />
            </div>
            <div className="flex items-center gap-2 text-gray-500 mr-4" data-id="element-352">
              <Phone size={18} data-id="element-353" />
            </div>
            <div className="flex items-center gap-2 text-gray-500" data-id="element-354">
              <Video size={18} data-id="element-355" />
            </div>
          </div>
          <div className="flex items-center mb-2" data-id="element-356">
            <List size={18} className="text-gray-500 mr-4" data-id="element-357" />
            <ListFilter size={18} className="text-gray-500 mr-4" data-id="element-358" />
            <Smile size={18} className="text-gray-500 mr-4" data-id="element-359" />
            <Image size={18} className="text-gray-500 mr-4" data-id="element-360" />
            <div className="ml-auto flex items-center gap-2 text-gray-500" data-id="element-361">
              <div className="w-6 h-6 bg-blue-100 rounded flex items-center justify-center text-blue-500 font-bold text-xs" data-id="element-362">
                A
              </div>
              <Settings size={18} data-id="element-363" />
              <div className="w-6 h-6 bg-blue-100 rounded flex items-center justify-center text-blue-500 font-bold text-xs" data-id="element-364">
                +
              </div>
            </div>
          </div>
          <div className="border rounded-lg p-3" data-id="element-365">
            <div className="text-gray-400" data-id="element-366">Type your message</div>
          </div>
          <div className="flex items-center mt-3" data-id="element-367">
            <div className="flex items-center gap-3 text-gray-500" data-id="element-368">
              <Paperclip size={18} data-id="element-369" />
              <FileText size={18} data-id="element-370" />
              <Smile size={18} data-id="element-371" />
              <Star size={18} data-id="element-372" />
              <Circle size={18} data-id="element-373" />
              <MoreHorizontal size={18} data-id="element-374" />
            </div>
            <div className="ml-auto flex items-center gap-2" data-id="element-375">
              <div className="flex items-center text-blue-500 font-medium" data-id="element-376">
                <RefreshCw size={16} className="mr-1" data-id="element-377" />
                Transfer
              </div>
              <button className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white" data-id="element-378">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-379">
                  <path d="M5 12h14M12 5l7 7-7 7" data-id="element-380" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const Video = ({
  size,
  className
}: {
  size: number;
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-381">
    <path d="M22 8.5V15.5C22 16.3 21.3 17 20.5 17H3.5C2.7 17 2 16.3 2 15.5V8.5C2 7.7 2.7 7 3.5 7H20.5C21.3 7 22 7.7 22 8.5Z" data-id="element-382" />
    <path d="M14 12L10 9V15L14 12Z" data-id="element-383" />
  </svg>;
const ChatItem = ({
  initials,
  name,
  message,
  time,
  category,
  bgColor,
  badge,
  active = false
}: {
  initials: string;
  name: string;
  message: string;
  time: string;
  category: string;
  bgColor: string;
  badge?: string;
  active?: boolean;
}) => {
  return <div className={`p-3 border-b hover:bg-gray-50 cursor-pointer ${active ? 'bg-blue-50' : ''}`} data-id="element-384">
      <div className="flex" data-id="element-385">
        <div className="relative mr-3" data-id="element-386">
          <div className={`w-8 h-8 ${bgColor} rounded-full flex items-center justify-center text-xs font-medium`} data-id="element-387">
            {initials}
          </div>
          {badge && <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center" data-id="element-388">
              <span className="text-[8px] text-white" data-id="element-389">{badge}</span>
            </div>}
        </div>
        <div className="flex-1" data-id="element-390">
          <div className="flex justify-between" data-id="element-391">
            <div className="font-medium" data-id="element-392">{name}</div>
            <div className="text-xs text-gray-500" data-id="element-393">{time}</div>
          </div>
          <div className="flex justify-between items-center mt-1" data-id="element-394">
            <div className="text-sm text-gray-500 flex-1 truncate" data-id="element-395">
              {message}
            </div>
            <div className="ml-2" data-id="element-396">
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded" data-id="element-397">
                {category}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const CollapsibleSection = ({
  title
}: {
  title: string;
}) => {
  return <div className="border-t p-3 flex items-center justify-between" data-id="element-398">
      <div className="flex items-center" data-id="element-399">
        <span className="text-sm font-medium" data-id="element-400">{title}</span>
        <ChevronDown size={16} className="ml-1 text-gray-500" data-id="element-401" />
      </div>
    </div>;
};